export default class TaskActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_BRANCH='GET_HELPER_BRANCH';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: TaskActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: TaskActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: TaskActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: TaskActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: TaskActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: TaskActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: TaskActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: TaskActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: TaskActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: TaskActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: TaskActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: TaskActions.GET_HELPER_BRANCH,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: TaskActions.ERROR_SERVER,
      payload: error
    };
  }
}